import styles from './delete-instructor-dialog.module.scss';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../../requestUtils';
import { useContext, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { IInstructor } from '../../../../_models/instructor';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeleteInstructorDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  instructorId: string
}

export function DeleteInstructorDialog(props: DeleteInstructorDialogProps) {
  const { data: instructor }: { data: IInstructor } = useCourseGetRequestHook(`resource/instructor/${props.instructorId}`, undefined);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const fullName = () => {
    return instructor?.person?.firstName + ' ' + instructor?.person?.lastName
  };

  const handleDeleteInstructor = () => {
    setLoading(true);
    makeCourseRequest(`resource/instructor/delete/${props.instructorId}`, 'DELETE').then(result => {
      setSnackbarMessage({ content: t('deleteInstructor.deletedInstructorFromList'), type: "success" });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('deleteInstructor.couldNotDeleteInstructorFromList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('deleteInstructor.areYouSureYouWantToDeleteInstructor')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-2'>
          {fullName()}
        </Typography>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {instructor?.person.email}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='error'
          onClick={handleDeleteInstructor}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('standard.delete')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteInstructorDialog;
